<template>
	<div class="pdfPreview">
		<el-dialog custom-class="lzdialogPanding" :visible.sync="dialog.show" :width="width" @close="close" top="1vh" center :close-on-click-modal="false">
			<iframe id="pdf" style="width: 100%; height: 100vh;" :src="src" v-if="src"></iframe>
		</el-dialog>
		
		
	</div>
</template>

<script>
	let that 
	import {
		mapGetters
	} from 'vuex'

	export default {
		computed: {
			...mapGetters(['api']),
		},
		name: 'pdfPreview',
		props: {
			close:{type:Function},
			confirm: {type:Function},
			cancel: {type:Function},
			width: {
				type: String,
				default: '80%'
			},
			src:{
				type: String,
				default: ''
			}
		},
		data() {
			return {
				dialog:{
					show:false
				}
			}
		},
		mounted() {
			that =this
		},
		methods: {
			show(data){
				this.dialog.show=true
			},
		}
	}
</script>

<style lang="scss" scoped>
	
	.pdfPreview {
		
	}
</style>



// WEBPACK FOOTER //
// src/components/pdfPreview/pdfPreview.vue